import * as React from 'react';
import styled from 'styled-components';

import { fontWeights } from '../../ui/inline-styles/variables';
import CoreChangerConatiner from '../containers/CoreChanger.container';
import BlurredBackground from './BlurredBackground';
import PatternBackground from './PatternBackground';

interface Props {
  pageHeader: React.ReactNode;
  pageFooter: React.ReactNode;
  dateLocation: React.ReactNode;
  outdoorAirData: React.ReactNode;
  snapshot: React.ReactNode;
}

const StDashboardTemplate = styled.main`
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  display: block;
  margin: 0;
  padding: 72px 136px;
`;

const StPageHeader = styled.header`
  display: inline-flex;
  margin: 0 0 72px 0;
`;

const StPageFooter = styled.footer`
  position: fixed;
  left: 50%;
  bottom: 16px;
  transform: translateX(-50%);
`;

const StDateTimeWeatherSection = styled.section`
  display: flex;
  justify-content: space-between;
  margin: 0 0 80px 0;
`;

const StSnapshotSection = styled.section`
  width: 100%;
`;

const StPoweredByTitle = styled.span`
  position: fixed;
  top: 16px;
  right: 40px;
  opacity: 0.7;
  font-size: 1.25rem;
  font-weight: ${fontWeights.regular};
  line-height: 2;
  color: #ffffff;
`;

class DashboardTemplate extends React.Component<Props> {
  render() {
    const { pageHeader, pageFooter, dateLocation, outdoorAirData, snapshot } = this.props;

    return (
      <>
        <BlurredBackground />
        <PatternBackground />
        <StDashboardTemplate>
          <StPageHeader>{pageHeader}</StPageHeader>
          <StDateTimeWeatherSection>
            {dateLocation}
            {outdoorAirData}
          </StDateTimeWeatherSection>
          <StSnapshotSection>{snapshot}</StSnapshotSection>
        </StDashboardTemplate>
        <StPoweredByTitle>Powered by Awair</StPoweredByTitle>
        <StPageFooter>{pageFooter}</StPageFooter>
        <CoreChangerConatiner />
      </>
    );
  }
}

export default DashboardTemplate;



// WEBPACK FOOTER //
// ./src/app/dashboard/components/DashboardTemplate.tsx